// lib/features/floatingContent/floatingContent.hook.ts
import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { getFloatingContent } from "./floatingContent.thunk";
import { isLoading, isSuccess, isError, isIdle } from "@/app/utils/asyncStatus";

const useFloatingContent = () => {
  const dispatch = useAppDispatch();
  const { data, status, error } = useAppSelector(
    (state) => state.floatingContent,
  );

  const fetchFloatingContent = useCallback(() => {
    dispatch(getFloatingContent());
  }, [dispatch]);

  const floatingMenu = useMemo(() => data?.floating_menu ?? [], [data]);

  const tozyItem = useMemo(
    () => floatingMenu.find((item) => item.key === "tozy") ?? null,
    [floatingMenu],
  );

  const appPromotionItem = useMemo(
    () => floatingMenu.find((item) => item.key === "app_promotion") ?? null,
    [floatingMenu],
  );

  const supportItem = useMemo(
    () => floatingMenu.find((item) => item.key === "support") ?? null,
    [floatingMenu],
  );

  return {
    data,
    floatingMenu,
    tozyItem,
    appPromotionItem,
    supportItem,
    status,
    error,
    isIdle: isIdle(status),
    isLoading: isLoading(status),
    isSuccess: isSuccess(status),
    isError: isError(status),
    fetchFloatingContent,
  };
};

export default useFloatingContent;
